import "./themes.css.ts.vanilla-4ed993c7.js";
const o = {
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1440
}, a = Object.fromEntries(
  Object.entries(o).map(([e, s]) => [e, `screen and (min-width: ${s}px)`])
), m = Object.fromEntries(
  Object.entries(a).map(([e, s]) => [e, { "@media": s }])
), d = ({ mobile: e, desktop: s }) => ({
  ...e,
  "@media": {
    [a.md]: s
  }
}), r = (e, s) => e ? e + "." + s : s;
function c(e, s = "") {
  return Object.entries(e).reduce((b, [t, n]) => typeof n == "object" ? { ...b, ...c(n, r(s, t)) } : { ...b, [r(s, t)]: n }, {});
}
const u = (e) => e.filter(Boolean).join(" ");
var l = { sm: "nbbs0e0", md: "nbbs0e1", lg: "nbbs0e2" }, j = { 1: "nbbs0e4", 2: "nbbs0e5", 3: "nbbs0e6", 4: "nbbs0e7", 5: "nbbs0e8", 6: "nbbs0e9", special: "nbbs0e3", eyebrow: "nbbs0ea", sm: "nbbs0eb" }, f = { 400: "nbbs0ec", 500: "nbbs0ed", 600: "nbbs0ee", 700: "nbbs0ef" };
export {
  o as a,
  l as b,
  u as c,
  m as d,
  c as f,
  j as h,
  a as q,
  d as r,
  f as w
};
//# sourceMappingURL=text.css-74722338.js.map
